/**
 * features/admin/usersWrite.ts
 * The allowlist is keyed by lowercased email so the admin can add a
 * teammate before they first sign in. On their next Google/email
 * sign-in the role resolves and they gain access.
 */
import { deleteDoc, doc } from 'firebase/firestore';
import { db, setDoc, updateDoc } from '@/lib/firebase';
import { COLLECTIONS, type UserRole } from '@/types';

export function emailId(email: string): string {
  return email.trim().toLowerCase();
}

export async function createUser(
  input: { email: string; name?: string; role: UserRole },
  actor: string,
): Promise<string> {
  const id = emailId(input.email);
  await setDoc(doc(db, COLLECTIONS.users, id), {
    email: id,
    displayName: input.name?.trim() || undefined,
    role: input.role,
    active: true,
    createdAt: new Date().toISOString(),
    createdBy: actor,
  });
  return id;
}

export async function updateUserRole(id: string, role: UserRole): Promise<void> {
  await updateDoc(doc(db, COLLECTIONS.users, id), { role, updatedAt: new Date().toISOString() });
}

export async function setUserActive(id: string, active: boolean): Promise<void> {
  await updateDoc(doc(db, COLLECTIONS.users, id), { active, updatedAt: new Date().toISOString() });
}

export async function deleteUser(id: string): Promise<void> {
  await deleteDoc(doc(db, COLLECTIONS.users, id));
}
